"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
require("core-js/modules/es7.string.pad-start");
var _shopList = require("@/api/shop/shopList");
var _wechatEvaluate = require("@/api/evaluate/wechatEvaluate");
var _orderEvaluate = require("@/api/evaluate/orderEvaluate");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'orderEvaluate',
  data: function data() {
    // 设置默认日期范围为近三个月
    var endDate = new Date();
    var startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 3);
    var formatDateTime = function formatDateTime(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    };
    return {
      // 搜索表单数据
      searchForm: {
        cityId: '',
        areaId: '',
        shopId: '',
        scene: '',
        startDate: formatDateTime(startDate) + ' 00:00:00',
        endDate: formatDateTime(endDate) + ' 23:59:59',
        phone: '',
        hasImg: null
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页相关
      regionOptions: [],
      areaOptions: [],
      storeList: [],
      currentPage: 1,
      pageSize: 20,
      total: 100
    };
  },
  created: function created() {
    var _this = this;
    (0, _shopList.getEffectiveCityList)().then(function (res) {
      _this.regionOptions = res.data;
      console.log(_this.formData);
    });
    (0, _shopList.getAreaList)().then(function (res) {
      _this.areaOptions = res.data;
    });
    this.getShops();
    this.loadData();
  },
  methods: {
    // 格式化分数显示
    formatScore: function formatScore(score) {
      if (score === null || score === undefined || score === '') {
        return '-';
      }
      // 如果是整数，直接返回；如果是小数，保留最多2位小数
      var num = parseFloat(score);
      if (isNaN(num)) return '-';
      return Number.isInteger(num) ? num : num.toFixed(2).replace(/\.?0+$/, '');
    },
    // 搜索方法
    handleSearch: function handleSearch() {
      console.log('搜索条件:', this.searchForm);
      // 这里可以调用API获取搜索结果
      this.loadData();
    },
    // 结束日期变化时自动设置为 23:59:59
    handleEndDateChange: function handleEndDateChange(val) {
      if (val) {
        // 提取日期部分，拼接 23:59:59
        var datePart = val.substring(0, 10);
        this.searchForm.endDate = datePart + ' 23:59:59';
      }
    },
    //时间转换
    formatDate: function formatDate(date) {
      var formatB = function formatB(t) {
        return new Intl.DateTimeFormat('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        }).format(new Date(+t)).replace(/\//g, '-').replace(/\s/, ' ').replace(/:/g, ':');
      };
      return formatB(date);
    },
    // 获取用户会员卡类型
    getUserRankType: function getUserRankType(userRank) {
      var rank = parseInt(userRank) || 0;
      // const rankLevel = Math.floor(rank / 10);
      var rankMap = {
        1: '普卡',
        2: '银卡',
        3: '金卡',
        4: '黑金卡',
        5: '钻石卡'
      };
      return rankMap[rank] || '普通游客';
    },
    // 拼接评论图片URL
    getCommentImageUrl: function getCommentImageUrl(url) {
      if (!url) return '';
      // 如果已经是完整URL，直接返回
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 拼接CDN前缀
      return process.env.VUE_APP_COMMENT_IMAGE_URL + url;
    },
    // 审核操作
    handleAudit: function handleAudit(row) {
      var _this2 = this;
      this.$confirm('确认审核该评价？审核后评价将在小程序展示', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 执行审核操作
        (0, _orderEvaluate.updateOrderEvaluatelndex)({
          id: row.id,
          status: 1
        }).then(function (res) {
          console.log('审核评价:', row);
          _this2.$message.success('审核成功');
          _this2.loadData();
        });
      }).catch(function () {
        _this2.$message.info('已取消审核');
      });
    },
    // 撤审操作
    handleUnaudit: function handleUnaudit(row) {
      var _this3 = this;
      this.$confirm('确认撤回审核？撤回后评价将不在小程序展示', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 执行撤审操作
        (0, _orderEvaluate.updateOrderEvaluatelndex)({
          id: row.id,
          status: 0
        }).then(function (res) {
          console.log('撤回评价:', row);
          _this3.$message.success('撤审成功');
          _this3.loadData();
        });
      }).catch(function () {
        _this3.$message.info('已取消撤审');
      });
    },
    handleExport: function handleExport(row) {
      var _this4 = this;
      (0, _orderEvaluate.downloadOrderEvaluateList)(this.searchForm).then(function (res) {
        _this4.$message.success('导出成功，请到导出日志下载');
      });
    },
    // 分页相关方法
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.loadData();
    },
    getShops: function getShops() {
      var _this5 = this;
      (0, _shopList.getStoreData)().then(function (res) {
        console.log(res.records);
        _this5.storeList = res.records;
      });
    },
    handleCurrentChange: function handleCurrentChange(page) {
      this.currentPage = page;
      this.loadData();
    },
    // 加载数据
    loadData: function loadData() {
      var _this6 = this;
      // 模拟数据加载
      console.log('加载数据 - 页码:', this.currentPage, '每页:', this.pageSize);
      console.log('搜索参数:', this.searchForm);
      this.tableLoading = true;

      // 处理参数：区域为5（全国）时传空
      var params = _objectSpread({}, this.searchForm);
      if (params.areaId === 5) {
        params.areaId = '';
      }

      // 添加分页参数
      params.page = this.currentPage;
      params.limit = this.pageSize;

      // 实际项目中这里会调用API
      (0, _orderEvaluate.getOrderEvaluatelndex)(params).then(function (res) {
        _this6.tableData = res.records;
        _this6.total = res.total;
        _this6.tableLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
};